import { defineMessages } from 'react-intl';

export const scope = 'app.components.AccessLinkRejected';

// Copy for an email/text link whose token the server refused, on the page and in the redirect snackbars.
export const messages = defineMessages({
  expiredTitle: {
    id: `${scope}.expiredTitle`,
    defaultMessage: 'This link has expired.'
  },
  invalidTitle: {
    id: `${scope}.invalidTitle`,
    defaultMessage: 'This link isn\'t valid.'
  },
  body: {
    id: `${scope}.body`,
    defaultMessage: 'Sign in to see your player, or open the most recent link from your email or text.'
  },
  signIn: {
    id: `${scope}.signIn`,
    defaultMessage: 'Sign in'
  },
  expiredViewingSignedIn: {
    id: `${scope}.expiredViewingSignedIn`,
    defaultMessage: 'This link has expired. You\'re viewing your signed-in page instead.'
  },
  invalidViewingSignedIn: {
    id: `${scope}.invalidViewingSignedIn`,
    defaultMessage: 'This link isn\'t valid. You\'re viewing your signed-in page instead.'
  },
});
